import auth from './auth';
import clients from './clients';
import csv from './csv';
import policies from './policies';
import quotes from './quotes';
import search from './search';
import newClient from './newClient';

export default {
  ...auth,
  ...clients,
  ...csv,
  ...policies,
  ...quotes,
  ...search,
  ...newClient,
};
